import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";

import Select from 'react-select';


interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
}

const News = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [searchNotFound, setSearchNotFound] = useState<string>('');

  const [newData, setNewData] = useState<NewsStructure[]>([]);


  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async () => {
    
    //console.log('Searching for:', searchQuery);
  
    try {
      // Make sure the searchQuery is not empty before making the request
      if (!searchQuery) {
        alert('Please enter a search term');
        return;
      }
  
      // Sending a GET request to the backend with the search query
      const response = await axios.get(`${api}/auth/news/search/${searchQuery}`);
      //console.log('news data',response.data)
      setNewData(response.data);
      
      // Log the response data for debugging
      //console.log('Search results:', response.data);
      setSearchNotFound('');
      // Handle the data (e.g., updating state, displaying results)
      // For example, you could update the state here
      // setSearchResults(response.data);
  
    } catch (error) {
      setSearchNotFound('Not Found')
      console.error('Error during search:', error);
    }
  };
  


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news`
        );

        //console.log('news data',response.data)
        setNewData(response.data);
        //console.log("news data in a array",newData);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/inserdata`
        );

        //console.log('media data inserted',response.data)
        setNewData(response.data);
        //console.log("media data in a array",newData);
      } catch (error) {
        console.error("media data Not Found:", error);
      }
    };

    fetchData();
  }, []);

 
  
 
  return (
    <div>
         {/* news header  */}
         <div
  className="flex justify-between items-center sticky top-0 z-10 px-12  w-full left-0 right-0 h-[74px]"
  style={{
    WebkitBackdropFilter: 'blur(22px)',
    backdropFilter: 'blur(22px)',
  }}
>
            
            
            <div>
            <div className='bg-transparent border h-[45px] border-darkblue px-2 rounded-lg flex justify-between items-center text-darkblue'>
               <input type="search" name="search" id="" className='placeholder-darkblue border-none outline-none bg-transparent' 
               value={searchQuery} 
               onChange={(e) => setSearchQuery(e.target.value)}
                placeholder='Write here....'/>
               <button 
  className='cursor-pointer px-2 border-l border-darkblue h-full flex items-center justify-center' 
  onClick={handleSearch} // You can define a handleSearch function to perform the search
>
  Search
</button>
            </div>
            {searchNotFound && <p className="text-red-500">{searchNotFound}</p>}
            </div>
            

         </div>

         <div>

        
{newData.length > 0 ? (
     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4 sm:p-6 md:p-8 lg:p-12">
          {newData.map((item) => (
            <div className='bg-white rounded-lg p-2 drop-shadow-md'>
              <img
      className="h-[230px] object-cover w-full max-w-full rounded-lg"
      src={
        item.img
          ? item.img.startsWith("http")
            ? item.img // Use the full URL if already valid
            : `${api}/${item.img}` // Prepend base URL for relative paths
          : "https://via.placeholder.com/150" // Placeholder image for missing URLs
      }
      alt={item.title || "Image"}
    />
               
               <h3 className='font-semibold text-lg py-4 '>{item.title}</h3>
               
               
            </div>
          ))}
       </div>
      ) : (
        <p>Loading...</p>
      )}
         </div>
          
        
    </div>
  )
}




export default News